// extracted by mini-css-extract-plugin
export default {"childrenWrapper":"eH50g1","physicalLayout":"gGzGW3","logicalLayout":"BhA0mS","childrenWrapperDirection":"fr3A7J"};